import React, { HTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react';

export interface VoxelDataTableCellProps
  extends Pick<
    ThHTMLAttributes<HTMLTableCellElement>,
    'align' | 'onClick' | 'colSpan' | 'onMouseDown'
  > {
  paddingClass?: string;
  borderClass?: string;
  className?: string;
  children?: any;
  type?: 'number' | 'text';
}

export const VoxelDataTableCell = React.forwardRef<HTMLTableCellElement, VoxelDataTableCellProps>(
  (
    {
      onClick,
      align,
      colSpan,
      onMouseDown,
      children,
      className,
      paddingClass = 'px-3 py-[6px]',
      borderClass = 'border-y border-solid border-black/5',
      type = 'text',
      ...props
    },
    ref
  ) => {
    return (
      <td
        align={align}
        className={`
          ${borderClass}
          
          ${type === 'number' ? 'text-[13px] font-medium text-voxel-gray-700' : 'text-[13px] font-normal text-gray-900'}
          ${className}
          ${paddingClass}
        `}
        {...props}
        ref={ref}
      >
        {children}
      </td>
    );
  }
);

export default VoxelDataTableCell;
